import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { internationalExchangePrograms } from '../../mocks/programs';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const ProgramsPage = () => {
  const [activeTab, setActiveTab] = useState<'oneday' | 'career-concert' | 'international' | 'career' | 'university' | 'startup'>('oneday');

  useEffect(() => {
    const hash = window.location.hash.replace('#', '') as 'oneday' | 'career-concert' | 'international' | 'career' | 'university' | 'startup';
    if (hash && ['oneday', 'career-concert', 'international', 'career', 'university', 'startup'].includes(hash)) {
      setActiveTab(hash);
    }
  }, []);

  const handleTabChange = (tab: 'oneday' | 'career-concert' | 'international' | 'career' | 'university' | 'startup') => {
    setActiveTab(tab);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-[#FDFBF7]">
      <Navbar />

      {/* Hero Section with Background Image */}
      <section className="relative pt-32 md:pt-40 pb-16 md:pb-24 px-6 overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0 z-0">
          <img
            src="https://public.readdy.ai/ai/img_res/66d9007569e67c383db36189f9f3a1ae.jpg"
            alt="Programs Background"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
        </div>

        {/* Content */}
        <div className="relative z-10 max-w-5xl mx-auto text-center">
          <span className="text-sm md:text-base tracking-[0.3em] text-white/90 font-medium uppercase mb-4 md:mb-6 block" style={{ fontFamily: 'Pretendard, sans-serif' }}>
            Programs
          </span>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-6 md:mb-8 tracking-tight" style={{ fontFamily: 'Pretendard, sans-serif' }}>
            사업 프로그램
          </h1>
          <p className="text-base md:text-lg text-white/90 leading-relaxed max-w-2xl mx-auto font-medium" style={{ fontFamily: 'Pretendard, sans-serif' }}>
            글로벌 역량 강화를 위한 다양한 교육 프로그램을 제공합니다
          </p>
        </div>
      </section>

      {/* Tab Navigation with Banner Style */}
      <section className="sticky top-20 z-40 bg-[#3E2E1E] shadow-md">
        <div className="max-w-6xl mx-auto px-4 md:px-6">
          <div className="flex justify-start md:justify-center gap-4 md:gap-6 lg:gap-10 py-4 md:py-6 overflow-x-auto">
            <button
              onClick={() => handleTabChange('oneday')}
              className={`text-sm md:text-base font-medium transition-all whitespace-nowrap cursor-pointer pb-2 border-b-2 ${
                activeTab === 'oneday'
                  ? 'border-white text-white font-bold'
                  : 'border-transparent text-white/70 hover:text-white'
              }`}
              style={{ fontFamily: 'Pretendard, sans-serif' }}
            >
              원데이클래스
            </button>
            <button
              onClick={() => handleTabChange('career-concert')}
              className={`text-sm md:text-base font-medium transition-all whitespace-nowrap cursor-pointer pb-2 border-b-2 ${
                activeTab === 'career-concert'
                  ? 'border-white text-white font-bold'
                  : 'border-transparent text-white/70 hover:text-white'
              }`}
              style={{ fontFamily: 'Pretendard, sans-serif' }}
            >
              진로콘서트
            </button>
            <button
              onClick={() => handleTabChange('international')}
              className={`text-sm md:text-base font-medium transition-all whitespace-nowrap cursor-pointer pb-2 border-b-2 ${
                activeTab === 'international'
                  ? 'border-white text-white font-bold'
                  : 'border-transparent text-white/70 hover:text-white'
              }`}
              style={{ fontFamily: 'Pretendard, sans-serif' }}
            >
              국제교류 프로그램
            </button>
            <button
              onClick={() => handleTabChange('career')}
              className={`text-sm md:text-base font-medium transition-all whitespace-nowrap cursor-pointer pb-2 border-b-2 ${
                activeTab === 'career'
                  ? 'border-white text-white font-bold'
                  : 'border-transparent text-white/70 hover:text-white'
              }`}
              style={{ fontFamily: 'Pretendard, sans-serif' }}
            >
              진로 특강
            </button>
            <button
              onClick={() => handleTabChange('university')}
              className={`text-sm md:text-base font-medium transition-all whitespace-nowrap cursor-pointer pb-2 border-b-2 ${
                activeTab === 'university'
                  ? 'border-white text-white font-bold'
                  : 'border-transparent text-white/70 hover:text-white'
              }`}
              style={{ fontFamily: 'Pretendard, sans-serif' }}
            >
              대학 탐방
            </button>
            <button
              onClick={() => handleTabChange('startup')}
              className={`text-sm md:text-base font-medium transition-all whitespace-nowrap cursor-pointer pb-2 border-b-2 ${
                activeTab === 'startup'
                  ? 'border-white text-white font-bold'
                  : 'border-transparent text-white/70 hover:text-white'
              }`}
              style={{ fontFamily: 'Pretendard, sans-serif' }}
            >
              창업 & 자격증
            </button>
          </div>
        </div>
      </section>

      {/* One-day Class Program */}
      {activeTab === 'oneday' && (
        <section id="oneday" className="py-16 md:py-24 px-6">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-16 md:mb-20">
              <span className="text-sm md:text-base tracking-[0.3em] text-[#8B7355] font-medium uppercase mb-4 md:mb-5 block" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                One-day Class
              </span>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#2C2416] mb-3 md:mb-4 tracking-tight" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                원데이 클래스 프로그램 (현장방문형)
              </h2>
              <div className="w-full max-w-[340px] h-0.5 bg-[#8B7355] mx-auto mt-4 md:mt-6 mb-6 md:mb-8"></div>
              <p className="text-base md:text-lg text-[#6B5D4F] max-w-3xl mx-auto leading-relaxed font-medium" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                체험 장소에 참가자가 직접 방문하여 현장 라운딩과 전문 직업인 멘토의 지도를 통해<br />
                심층적인 직업 경험을 진행합니다. 이를 통해 학생들이 다양한 직업 세계를 이해하고<br />
                올바른 진로 방향을 설정할 수 있도록 돕습니다.
              </p>
            </div>

            {/* Main Image */}
            <div className="relative h-[300px] md:h-[500px] rounded-lg overflow-hidden mb-16 md:mb-24">
              <img
                src="https://readdy.ai/api/search-image?query=large%20group%20of%20korean%20high%20school%20students%20in%20school%20uniforms%20sitting%20in%20rows%20in%20bright%20modern%20school%20auditorium%20listening%20to%20career%20lecture%20seminar%2C%20students%20focused%20and%20attentive%20taking%20notes%20with%20notebooks%20and%20pens%2C%20professional%20speaker%20standing%20at%20podium%20with%20presentation%20screen%20behind%2C%20warm%20indoor%20lighting%20with%20natural%20light%20from%20windows%2C%20authentic%20educational%20lecture%20scene%2C%20professional%20documentary%20photography%20style&width=1200&height=800&seq=oneday-class-main-001&orientation=landscape"
                alt="원데이 클래스"
                className="w-full h-full object-cover"
              />
            </div>

            {/* Overview with Icons */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-16 mb-24 md:mb-32">
              <div className="bg-[#F5EFE7] p-8 md:p-10 rounded-lg text-center">
                <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 md:mb-6 bg-[#8B7355] rounded-full">
                  <i className="ri-calendar-line text-xl md:text-2xl text-white"></i>
                </div>
                <h3 className="text-lg md:text-xl font-bold text-[#2C2416] mb-4 md:mb-6" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                  운영 시기
                </h3>
                <p className="text-base md:text-lg text-[#6B5D4F] font-medium leading-relaxed" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                  1월 ~ 12월 (연중 운영)
                </p>
              </div>

              <div className="bg-[#F5EFE7] p-8 md:p-10 rounded-lg text-center">
                <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 md:mb-6 bg-[#8B7355] rounded-full">
                  <i className="ri-time-line text-xl md:text-2xl text-white"></i>
                </div>
                <h3 className="text-lg md:text-xl font-bold text-[#2C2416] mb-4 md:mb-6" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                  운영 시간
                </h3>
                <p className="text-base md:text-lg text-[#6B5D4F] font-medium leading-relaxed" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                  약 2시간 진행<br />
                  (운영 장소별 조금씩 상이)
                </p>
              </div>

              <div className="bg-[#F5EFE7] p-8 md:p-10 rounded-lg text-center">
                <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 md:mb-6 bg-[#8B7355] rounded-full">
                  <i className="ri-user-line text-xl md:text-2xl text-white"></i>
                </div>
                <h3 className="text-lg md:text-xl font-bold text-[#2C2416] mb-4 md:mb-6" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                  운영 대상
                </h3>
                <p className="text-base md:text-lg text-[#6B5D4F] font-medium leading-relaxed" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                  한국 중·고등학생
                </p>
              </div>
            </div>

            {/* Partner Logos */}
            <div className="mb-24 md:mb-32">
              <h3 className="text-xl md:text-2xl font-bold text-[#2C2416] mb-8 md:mb-12 text-center" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                연계 기관
              </h3>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8 items-center mb-6 md:mb-8">
                <div className="bg-white p-4 md:p-6 rounded-lg border border-[#E8DFD0] flex items-center justify-center h-20 md:h-24">
                  <span className="text-base md:text-lg font-bold text-[#2C2416]" style={{ fontFamily: 'Pretendard, sans-serif' }}>아모레퍼시픽</span>
                </div>
                <div className="bg-white p-4 md:p-6 rounded-lg border border-[#E8DFD0] flex items-center justify-center h-20 md:h-24">
                  <span className="text-base md:text-lg font-bold text-[#2C2416]" style={{ fontFamily: 'Pretendard, sans-serif' }}>시사쿡요리학원</span>
                </div>
                <div className="bg-white p-4 md:p-6 rounded-lg border border-[#E8DFD0] flex items-center justify-center h-20 md:h-24">
                  <span className="text-base md:text-lg font-bold text-[#2C2416]" style={{ fontFamily: 'Pretendard, sans-serif' }}>Gen.G</span>
                </div>
                <div className="bg-white p-4 md:p-6 rounded-lg border border-[#E8DFD0] flex items-center justify-center h-20 md:h-24">
                  <span className="text-sm md:text-base font-bold text-[#2C2416] text-center" style={{ fontFamily: 'Pretendard, sans-serif' }}>모어댄스뮤직아카데미</span>
                </div>
              </div>
              <p className="text-center text-base md:text-lg text-[#6B5D4F] mt-4 md:mt-6 font-medium" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                외 100여 개 체험처 연계 가능 ❗
              </p>
            </div>

            {/* Process */}
            <div className="mb-24 md:mb-32">
              <h3 className="text-2xl md:text-3xl font-bold text-[#2C2416] mb-12 md:mb-16 text-center" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                프로그램 진행 프로세스
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                <div className="text-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 md:mb-6 bg-[#8B7355] text-white rounded-full text-xl md:text-2xl font-bold" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    1
                  </div>
                  <h4 className="text-base md:text-lg font-bold text-[#2C2416] mb-3 md:mb-4" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    체험 장소 리스트 공유
                  </h4>
                  <p className="text-sm md:text-base text-[#6B5D4F] font-medium leading-relaxed" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    다양한 체험 장소 정보를 제공합니다
                  </p>
                </div>

                <div className="text-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 md:mb-6 bg-[#8B7355] text-white rounded-full text-xl md:text-2xl font-bold" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    2
                  </div>
                  <h4 className="text-base md:text-lg font-bold text-[#2C2416] mb-3 md:mb-4" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    희망 체험 장소 취합
                  </h4>
                  <p className="text-sm md:text-base text-[#6B5D4F] font-medium leading-relaxed" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    학생들의 희망 장소를 수집합니다
                  </p>
                </div>

                <div className="text-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 md:mb-6 bg-[#8B7355] text-white rounded-full text-xl md:text-2xl font-bold" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    3
                  </div>
                  <h4 className="text-base md:text-lg font-bold text-[#2C2416] mb-3 md:mb-4" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    체험처 신청 및 확인
                  </h4>
                  <p className="text-sm md:text-base text-[#6B5D4F] font-medium leading-relaxed" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    프로그램 가능 여부를 확인합니다
                  </p>
                </div>

                <div className="text-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 md:mb-6 bg-[#8B7355] text-white rounded-full text-xl md:text-2xl font-bold" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    4
                  </div>
                  <h4 className="text-base md:text-lg font-bold text-[#2C2416] mb-3 md:mb-4" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    진행 일정 확정
                  </h4>
                  <p className="text-sm md:text-base text-[#6B5D4F] font-medium leading-relaxed" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    최종 일정을 확정합니다
                  </p>
                </div>

                <div className="text-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 md:mb-6 bg-[#8B7355] text-white rounded-full text-xl md:text-2xl font-bold" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    5
                  </div>
                  <h4 className="text-base md:text-lg font-bold text-[#2C2416] mb-3 md:mb-4" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    운영 계획 발송
                  </h4>
                  <p className="text-sm md:text-base text-[#6B5D4F] font-medium leading-relaxed" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    필요 시 상세 계획을 전달합니다
                  </p>
                </div>

                <div className="text-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 md:mb-6 bg-[#8B7355] text-white rounded-full text-xl md:text-2xl font-bold" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    6
                  </div>
                  <h4 className="text-base md:text-lg font-bold text-[#2C2416] mb-3 md:mb-4" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    프로그램 진행
                  </h4>
                  <p className="text-sm md:text-base text-[#6B5D4F] font-medium leading-relaxed" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    체험 프로그램을 실시합니다
                  </p>
                </div>
              </div>
            </div>

            {/* Important Notes */}
            <div className="bg-[#F5EFE7] py-12 md:py-16 px-8 md:px-12 rounded-lg">
              <h3 className="text-xl md:text-2xl font-bold text-[#2C2416] mb-8 md:mb-10 text-center" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                참고 사항
              </h3>
              <div className="space-y-5 md:space-y-6 max-w-3xl mx-auto">
                <div className="flex items-start gap-3 md:gap-4">
                  <div className="w-2 h-2 bg-[#8B7355] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-base md:text-lg text-[#5A4A3A] font-medium leading-relaxed" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    원데이 클래스 사전 조사지는 필수 작성 및 회신 요청
                  </p>
                </div>
                <div className="flex items-start gap-3 md:gap-4">
                  <div className="w-2 h-2 bg-[#8B7355] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-base md:text-lg text-[#5A4A3A] font-medium leading-relaxed" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    체험처별 준비 사항은 운영 계획을 통해 사전 안내
                  </p>
                </div>
                <div className="flex items-start gap-3 md:gap-4">
                  <div className="w-2 h-2 bg-[#8B7355] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-base md:text-lg text-[#5A4A3A] font-medium leading-relaxed" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    프로그램 운영 7일 전 이후 취소 불가<br />
                    (취소 시, 체험처별 이미  발생한 체험비는 신청자 부담)
                  </p>
                </div>
              </div>
            </div>

            {/* CTA */}
            <div className="text-center mt-12 md:mt-16">
              <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center">
                <Link
                  to="/apply"
                  className="inline-flex items-center justify-center gap-3 bg-[#8B7355] hover:bg-[#6d5a42] text-white px-6 md:px-8 py-3 md:py-3.5 rounded-full transition-all whitespace-nowrap cursor-pointer shadow-md hover:shadow-lg"
                >
                  <span className="text-sm md:text-base font-semibold" style={{ fontFamily: 'Pretendard, sans-serif' }}>프로그램 신청하기</span>
                  <i className="ri-arrow-right-line text-base md:text-lg"></i>
                </Link>
                <a
                  href="https://brancheduinfo.readdy.co"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-3 bg-white hover:bg-gray-50 text-[#2C2416] border-2 border-[#2C2416] px-6 md:px-8 py-3 md:py-3.5 rounded-full transition-all whitespace-nowrap cursor-pointer shadow-md hover:shadow-lg"
                >
                  <span className="text-sm md:text-base font-semibold" style={{ fontFamily: 'Pretendard, sans-serif' }}>체험 정보보기</span>
                  <i className="ri-map-pin-line text-base md:text-lg"></i>
                </a>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Career Concert Program */}
      {activeTab === 'career-concert' && (
        <section id="career-concert" className="py-16 md:py-24 px-6">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-16 md:mb-20">
              <span className="text-sm md:text-base tracking-[0.3em] text-[#8B7355] font-medium uppercase mb-4 md:mb-5 block" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                Career Concert
              </span>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#2C2416] mb-3 md:mb-4 tracking-tight" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                진로콘서트 (학교 & 기업 방문형 직업 경험)
              </h2>
              <div className="w-full max-w-[420px] h-0.5 bg-[#8B7355] mx-auto mt-4 md:mt-6 mb-6 md:mb-8"></div>
              <p className="text-base md:text-lg text-[#6B5D4F] max-w-3xl mx-auto leading-relaxed font-medium" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                전문 직업인 강사가 학교 또는 기업 현장으로 직접 방문하여<br />
                학급별로 다양한 직업을 체험할 수 있도록 지원합니다.<br />
                이를 통해 학생들이 다양한 직업 세계를 경험하며 자신의 진로를 탐색할 수 있도록 돕습니다.
              </p>
            </div>

            {/* Main Image */}
            <div className="relative h-[300px] md:h-[500px] rounded-lg overflow-hidden mb-16 md:mb-24">
              <img
                src="https://readdy.ai/api/search-image?query=professional%20career%20mentor%20conducting%20interactive%20hands-on%20workshop%20with%20korean%20high%20school%20students%20in%20bright%20modern%20classroom%2C%20students%20actively%20participating%20in%20career%20activities%20with%20enthusiasm%20and%20engagement%2C%20warm%20educational%20atmosphere%20with%20natural%20lighting%2C%20professional%20documentary%20photography%20style%2C%20authentic%20learning%20moment&width=1200&height=800&seq=career-concert-main-001&orientation=landscape"
                alt="진로콘서트"
                className="w-full h-full object-cover"
              />
            </div>

            {/* Overview with Icons */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-16 mb-24 md:mb-32">
              <div className="bg-[#F5EFE7] p-8 md:p-10 rounded-lg text-center">
                <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 md:mb-6 bg-[#8B7355] rounded-full">
                  <i className="ri-map-pin-line text-xl md:text-2xl text-white"></i>
                </div>
                <h3 className="text-lg md:text-xl font-bold text-[#2C2416] mb-4 md:mb-6" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                  운영 장소
                </h3>
                <p className="text-base md:text-lg text-[#6B5D4F] font-medium leading-relaxed" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                  학교 또는 기업 현장
                </p>
              </div>

              <div className="bg-[#F5EFE7] p-8 md:p-10 rounded-lg text-center">
                <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 md:mb-6 bg-[#8B7355] rounded-full">
                  <i className="ri-time-line text-xl md:text-2xl text-white"></i>
                </div>
                <h3 className="text-lg md:text-xl font-bold text-[#2C2416] mb-4 md:mb-6" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                  운영 시간
                </h3>
                <p className="text-base md:text-lg text-[#6B5D4F] font-medium leading-relaxed" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                  2~3시간<br />
                  (협의 가능)
                </p>
              </div>

              <div className="bg-[#F5EFE7] p-8 md:p-10 rounded-lg text-center">
                <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 md:mb-6 bg-[#8B7355] rounded-full">
                  <i className="ri-user-line text-xl md:text-2xl text-white"></i>
                </div>
                <h3 className="text-lg md:text-xl font-bold text-[#2C2416] mb-4 md:mb-6" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                  운영 대상
                </h3>
                <p className="text-base md:text-lg text-[#6B5D4F] font-medium leading-relaxed" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                  초·중·고등학생<br />
                  기업 임직원 등
                </p>
              </div>
            </div>

            {/* Main Content */}
            <div className="mb-24 md:mb-32">
              <h3 className="text-2xl md:text-3xl font-bold text-[#2C2416] mb-10 md:mb-12 text-center" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                프로그램 특징
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12">
                <div className="text-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 md:mb-6 bg-[#F5EFE7] rounded-full">
                    <i className="ri-user-voice-line text-xl md:text-2xl text-[#8B7355]"></i>
                  </div>
                  <h4 className="text-base md:text-lg font-bold text-[#2C2416] mb-3 md:mb-4" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    전문 직업인 멘토
                  </h4>
                  <p className="text-sm md:text-base text-[#6B5D4F] font-medium leading-relaxed" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    현직 전문가가 직접 방문하여 생생한 직업 세계를 전달합니다
                  </p>
                </div>

                <div className="text-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 md:mb-6 bg-[#F5EFE7] rounded-full">
                    <i className="ri-group-line text-xl md:text-2xl text-[#8B7355]"></i>
                  </div>
                  <h4 className="text-base md:text-lg font-bold text-[#2C2416] mb-3 md:mb-4" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    학급별 맞춤 운영
                  </h4>
                  <p className="text-sm md:text-base text-[#6B5D4F] font-medium leading-relaxed" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    각 학급의 특성과 요구에 맞춘 프로그램을 제공합니다
                  </p>
                </div>

                <div className="text-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 md:mb-6 bg-[#F5EFE7] rounded-full">
                    <i className="ri-hand-heart-line text-xl md:text-2xl text-[#8B7355]"></i>
                  </div>
                  <h4 className="text-base md:text-lg font-bold text-[#2C2416] mb-3 md:mb-4" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    실무 중심 체험
                  </h4>
                  <p className="text-sm md:text-base text-[#6B5D4F] font-medium leading-relaxed" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    이론이 아닌 실제 업무 경험을 바탕으로 한 체험 활동을 진행합니다
                  </p>
                </div>
              </div>
            </div>

            {/* Important Notes */}
            <div className="bg-[#F5EFE7] py-12 md:py-16 px-8 md:px-12 rounded-lg">
              <h3 className="text-xl md:text-2xl font-bold text-[#2C2416] mb-8 md:mb-10 text-center" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                참고 사항
              </h3>
              <div className="space-y-5 md:space-y-6 max-w-3xl mx-auto">
                <div className="flex items-start gap-3 md:gap-4">
                  <div className="w-2 h-2 bg-[#8B7355] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-base md:text-lg text-[#5A4A3A] font-medium leading-relaxed" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    학교 또는 기업의 요청에 따라 맞춤형 프로그램 구성 가능
                  </p>
                </div>
                <div className="flex items-start gap-3 md:gap-4">
                  <div className="w-2 h-2 bg-[#8B7355] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-base md:text-lg text-[#5A4A3A] font-medium leading-relaxed" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    사전 협의를 통해 체험 직업군 및 운영 방식 조율
                  </p>
                </div>
                <div className="flex items-start gap-3 md:gap-4">
                  <div className="w-2 h-2 bg-[#8B7355] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-base md:text-lg text-[#5A4A3A] font-medium leading-relaxed" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    강사비 및 재료비는 프로그램 내용에 따라 별도 안내
                  </p>
                </div>
              </div>
            </div>

            {/* CTA */}
            <div className="text-center mt-12 md:mt-16">
              <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center">
                <Link
                  to="/apply"
                  className="inline-flex items-center justify-center gap-3 bg-[#8B7355] hover:bg-[#6d5a42] text-white px-6 md:px-8 py-3 md:py-3.5 rounded-full transition-all whitespace-nowrap cursor-pointer shadow-md hover:shadow-lg"
                >
                  <span className="text-sm md:text-base font-semibold" style={{ fontFamily: 'Pretendard, sans-serif' }}>프로그램 신청하기</span>
                  <i className="ri-arrow-right-line text-base md:text-lg"></i>
                </Link>
                <a
                  href="https://brancheduinfo.readdy.co"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-3 bg-white hover:bg-gray-50 text-[#2C2416] border-2 border-[#2C2416] px-6 md:px-8 py-3 md:py-3.5 rounded-full transition-all whitespace-nowrap cursor-pointer shadow-md hover:shadow-lg"
                >
                  <span className="text-sm md:text-base font-semibold" style={{ fontFamily: 'Pretendard, sans-serif' }}>체험 정보보기</span>
                  <i className="ri-map-pin-line text-base md:text-lg"></i>
                </a>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* International Exchange Program */}
      {activeTab === 'international' && (
        <section id="international" className="py-16 md:py-24 px-6">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-16 md:mb-20">
              <span className="text-sm md:text-base tracking-[0.3em] text-[#8B7355] font-medium uppercase mb-4 md:mb-5 block" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                International Exchange
              </span>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#2C2416] mb-3 md:mb-4 tracking-tight" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                국제교류 프로그램
              </h2>
              <div className="w-full max-w-[280px] h-0.5 bg-[#8B7355] mx-auto mt-4 md:mt-6 mb-6 md:mb-8"></div>
              <p className="text-base md:text-lg text-[#5A4A3A] max-w-3xl mx-auto leading-relaxed font-medium" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                한국과 일본 간 문화·산업·진로 체험을 통한 글로벌 역량 강화 프로그램입니다.
              </p>
            </div>

            {/* Japan Experience */}
            <div className="mb-24 md:mb-32">
              <div className="text-center mb-12 md:mb-16">
                <span className="text-sm md:text-base tracking-[0.3em] text-[#8B7355] font-medium uppercase mb-4 md:mb-5 block" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                  Experience for Japan
                </span>
                <h3 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#2C2416] mb-3 md:mb-4 tracking-tight px-4" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                  일본으로 찾아가는 국제교류 체험
                </h3>
                <div className="w-full max-w-[420px] h-0.5 bg-[#8B7355] mx-auto mt-4 md:mt-6"></div>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 md:gap-16 items-center mb-12 md:mb-16">
                <div className="relative h-[400px] md:h-[550px] rounded-lg overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=korean%20high%20school%20students%20visiting%20advanced%20japanese%20robotics%20laboratory%20and%20ai%20technology%20center%2C%20students%20observing%20humanoid%20robots%20and%20artificial%20intelligence%20demonstrations%20with%20fascination%20and%20taking%20notes%2C%20modern%20clean%20research%20facility%20with%20white%20walls%20and%20high-tech%20equipment%20displays%2C%20professional%20educational%20documentary%20photography%20style%2C%20inspiring%20stem%20learning%20moment%20with%20bright%20clinical%20lighting%2C%20students%20wearing%20casual%20modern%20clothes%20showing%20genuine%20interest&width=800&height=1000&seq=japan-exchange-main-001&orientation=portrait"
                    alt="일본으로 찾아가는 국제교류 체험"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="space-y-6 md:space-y-8">
                  <div className="space-y-5 md:space-y-6">
                    <div className="flex flex-col md:flex-row md:items-start gap-2 md:gap-4">
                      <div className="w-full md:w-28 flex-shrink-0 text-base md:text-lg font-bold text-[#8B7355]" style={{ fontFamily: 'Pretendard, sans-serif' }}>대상</div>
                      <p className="text-base md:text-lg text-[#5A4A3A] font-medium" style={{ fontFamily: 'Pretendard, sans-serif' }}>한국 중·고등학생 및 대학생</p>
                    </div>
                    <div className="flex flex-col md:flex-row md:items-start gap-2 md:gap-4">
                      <div className="w-full md:w-28 flex-shrink-0 text-base md:text-lg font-bold text-[#8B7355]" style={{ fontFamily: 'Pretendard, sans-serif' }}>목표</div>
                      <p className="text-base md:text-lg text-[#5A4A3A] font-medium" style={{ fontFamily: 'Pretendard, sans-serif' }}>일본 소재 학교 방문 및 첨단 산업·직업 세계 체험</p>
                    </div>
                    <div className="flex flex-col md:flex-row md:items-start gap-2 md:gap-4">
                      <div className="w-full md:w-28 flex-shrink-0 text-base md:text-lg font-bold text-[#8B7355]" style={{ fontFamily: 'Pretendard, sans-serif' }}>운영 방식</div>
                      <p className="text-base md:text-lg text-[#5A4A3A] font-medium" style={{ fontFamily: 'Pretendard, sans-serif' }}>단기형, 장기형 (운영 협의 가능)</p>
                    </div>
                    <div className="flex flex-col md:flex-row md:items-start gap-2 md:gap-4">
                      <div className="w-full md:w-28 flex-shrink-0 text-base md:text-lg font-bold text-[#8B7355]" style={{ fontFamily: 'Pretendard, sans-serif' }}>주요 활동</div>
                      <div className="text-base md:text-lg text-[#5A4A3A] font-medium space-y-2" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                        <div className="flex items-center gap-2">
                          <span className="w-1.5 h-1.5 bg-[#8B7355] rounded-full flex-shrink-0"></span>
                          <span>일본 학교 수업 교류</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <span className="w-1.5 h-1.5 bg-[#8B7355] rounded-full flex-shrink-0"></span>
                          <span>일본 로봇·AI 기업 견학</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <span className="w-1.5 h-1.5 bg-[#8B7355] rounded-full flex-shrink-0"></span>
                          <span>장인 기술 체험</span>
                        </div>
                      </div>
                    </div>
                    <div className="flex flex-col md:flex-row md:items-start gap-2 md:gap-4">
                      <div className="w-full md:w-28 flex-shrink-0 text-base md:text-lg font-bold text-[#8B7355]" style={{ fontFamily: 'Pretendard, sans-serif' }}>특징</div>
                      <p className="text-base md:text-lg text-[#5A4A3A] font-medium" style={{ fontFamily: 'Pretendard, sans-serif' }}>단순 관광이 아닌 수업 참관과 진로 탐색 중심 프로그램</p>
                    </div>
                    <div className="flex flex-col md:flex-row md:items-start gap-2 md:gap-4">
                      <div className="w-full md:w-28 flex-shrink-0 text-base md:text-lg font-bold text-[#8B7355]" style={{ fontFamily: 'Pretendard, sans-serif' }}>참고 사항</div>
                      <p className="text-base md:text-lg text-[#5A4A3A] font-medium" style={{ fontFamily: 'Pretendard, sans-serif' }}>항공·비자·숙박까지 협조가 필요한 경우 별도 안내 요청 필수</p>
                    </div>
                  </div>
                  <div className="flex flex-col sm:flex-row gap-3 md:gap-4 mt-6">
                    <Link
                      to="/apply"
                      className="inline-flex items-center justify-center gap-3 bg-[#8B7355] hover:bg-[#6d5a42] text-white px-6 md:px-8 py-3 md:py-3.5 rounded-full transition-all whitespace-nowrap cursor-pointer shadow-md hover:shadow-lg"
                    >
                      <span className="text-sm md:text-base font-semibold" style={{ fontFamily: 'Pretendard, sans-serif' }}>프로그램 신청하기</span>
                      <i className="ri-arrow-right-line text-base md:text-lg"></i>
                    </Link>
                    <Link
                      to="/experience#japan-experience"
                      className="inline-flex items-center justify-center gap-3 bg-white hover:bg-gray-50 text-[#2C2416] border-2 border-[#2C2416] px-6 md:px-8 py-3 md:py-3.5 rounded-full transition-all whitespace-nowrap cursor-pointer shadow-md hover:shadow-lg"
                    >
                      <span className="text-sm md:text-base font-semibold" style={{ fontFamily: 'Pretendard, sans-serif' }}>체험 장소 보기</span>
                      <i className="ri-map-pin-line text-base md:text-lg"></i>
                    </Link>
                  </div>
                </div>
              </div>

              {/* Gallery */}
              <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
                <div className="aspect-[3/4] rounded-lg overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=korean%20students%20participating%20in%20japanese%20high%20school%20classroom%20exchange%20program%2C%20students%20sitting%20at%20desks%20interacting%20with%20japanese%20classmates%20during%20lesson%2C%20bright%20modern%20classroom%20with%20natural%20window%20light%20and%20educational%20materials%2C%20professional%20documentary%20photography%2C%20authentic%20cultural%20and%20educational%20exchange%20moment%2C%20warm%20friendly%20atmosphere&width=600&height=800&seq=japan-gallery-school-01&orientation=portrait"
                    alt="일본 학교 수업 교류"
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-500 cursor-pointer"
                  />
                </div>
                <div className="aspect-[3/4] rounded-lg overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=korean%20high%20school%20students%20touring%20japanese%20robotics%20and%20ai%20technology%20company%2C%20students%20wearing%20visitor%20badges%20observing%20advanced%20robots%20and%20automation%20systems%20with%20amazement%2C%20modern%20industrial%20facility%20with%20clean%20white%20environment%20and%20high-tech%20displays%2C%20professional%20educational%20photography%2C%20career%20exploration%20and%20innovation%20theme%2C%20bright%20indoor%20lighting&width=600&height=800&seq=japan-gallery-robot-02&orientation=portrait"
                    alt="일본 로봇·AI 기업 견학"
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-500 cursor-pointer"
                  />
                </div>
                <div className="aspect-[3/4] rounded-lg overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=korean%20students%20experiencing%20traditional%20japanese%20craftsmanship%20workshop%20with%20master%20artisan%2C%20students%20carefully%20learning%20traditional%20techniques%20and%20skills%20with%20focused%20expressions%2C%20authentic%20japanese%20workshop%20setting%20with%20natural%20wood%20and%20traditional%20tools%2C%20professional%20documentary%20photography%2C%20cultural%20heritage%20and%20skill%20learning%20moment%2C%20warm%20natural%20lighting&width=600&height=800&seq=japan-gallery-craft-03&orientation=portrait"
                    alt="장인 기술 체험"
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-500 cursor-pointer"
                  />
                </div>
                <div className="aspect-[3/4] rounded-lg overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=korean%20students%20visiting%20prestigious%20japanese%20university%20campus%20and%20research%20laboratory%2C%20students%20walking%20through%20modern%20academic%20buildings%20with%20professor%20guide%20showing%20facilities%2C%20bright%20contemporary%20university%20environment%20with%20glass%20architecture%2C%20professional%20educational%20documentary%20photography%2C%20academic%20aspiration%20and%20research%20exploration%20atmosphere%2C%20natural%20daylight&width=600&height=800&seq=japan-gallery-univ-04&orientation=portrait"
                    alt="대학 및 연구소 방문"
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-500 cursor-pointer"
                  />
                </div>
              </div>
            </div>

            {/* Korea Experience */}
            <div>
              <div className="text-center mb-12 md:mb-16">
                <span className="text-sm md:text-base tracking-[0.3em] text-[#8B7355] font-medium uppercase mb-4 md:mb-5 block" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                  Experience for Korea
                </span>
                <h3 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#2C2416] mb-3 md:mb-4 tracking-tight" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                  한국 유학 체험
                </h3>
                <div className="w-full max-w-[200px] h-0.5 bg-[#8B7355] mx-auto mt-4 md:mt-6"></div>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 md:gap-16 items-center mb-12 md:mb-16">
                <div className="space-y-6 md:space-y-8 order-2 lg:order-1">
                  <div className="space-y-5 md:space-y-6">
                    <div className="flex flex-col md:flex-row md:items-start gap-2 md:gap-4">
                      <div className="w-full md:w-28 flex-shrink-0 text-base md:text-lg font-bold text-[#8B7355]" style={{ fontFamily: 'Pretendard, sans-serif' }}>대상</div>
                      <p className="text-base md:text-lg text-[#5A4A3A] font-medium" style={{ fontFamily: 'Pretendard, sans-serif' }}>일본 중·고등학생 및 성인</p>
                    </div>
                    <div className="flex flex-col md:flex-row md:items-start gap-2 md:gap-4">
                      <div className="w-full md:w-28 flex-shrink-0 text-base md:text-lg font-bold text-[#8B7355]" style={{ fontFamily: 'Pretendard, sans-serif' }}>목표</div>
                      <p className="text-base md:text-lg text-[#5A4A3A] font-medium" style={{ fontFamily: 'Pretendard, sans-serif' }}>서울의 문화 및 산업 인프라 직접 체험</p>
                    </div>
                    <div className="flex flex-col md:flex-row md:items-start gap-2 md:gap-4">
                      <div className="w-full md:w-28 flex-shrink-0 text-base md:text-lg font-bold text-[#8B7355]" style={{ fontFamily: 'Pretendard, sans-serif' }}>운영 방식</div>
                      <p className="text-base md:text-lg text-[#5A4A3A] font-medium" style={{ fontFamily: 'Pretendard, sans-serif' }}>단기형, 장기형 (운영 협의 가능)</p>
                    </div>
                    <div className="flex flex-col md:flex-row md:items-start gap-2 md:gap-4">
                      <div className="w-full md:w-28 flex-shrink-0 text-base md:text-lg font-bold text-[#8B7355]" style={{ fontFamily: 'Pretendard, sans-serif' }}>주요 활동</div>
                      <div className="text-base md:text-lg text-[#5A4A3A] font-medium space-y-2" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                        <div className="flex items-center gap-2">
                          <span className="w-1.5 h-1.5 bg-[#8B7355] rounded-full flex-shrink-0"></span>
                          <span>서울 주요 명소 탐방 및 문화 체험</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <span className="w-1.5 h-1.5 bg-[#8B7355] rounded-full flex-shrink-0"></span>
                          <span>K-팝 / K-뷰티 체험</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <span className="w-1.5 h-1.5 bg-[#8B7355] rounded-full flex-shrink-0"></span>
                          <span>한국 기업 탐방</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <span className="w-1.5 h-1.5 bg-[#8B7355] rounded-full flex-shrink-0"></span>
                          <span>전문 자격증 취득 (선택형)</span>
                        </div>
                      </div>
                    </div>
                    <div className="flex flex-col md:flex-row md:items-start gap-2 md:gap-4">
                      <div className="w-full md:w-28 flex-shrink-0 text-base md:text-lg font-bold text-[#8B7355]" style={{ fontFamily: 'Pretendard, sans-serif' }}>특징</div>
                      <p className="text-base md:text-lg text-[#5A4A3A] font-medium" style={{ fontFamily: 'Pretendard, sans-serif' }}>관광 + 산업 체험 + 문화 교류 결합 프로그램</p>
                    </div>
                    <div className="flex flex-col md:flex-row md:items-start gap-2 md:gap-4">
                      <div className="w-full md:w-28 flex-shrink-0 text-base md:text-lg font-bold text-[#8B7355]" style={{ fontFamily: 'Pretendard, sans-serif' }}>참고 사항</div>
                      <p className="text-base md:text-lg text-[#5A4A3A] font-medium" style={{ fontFamily: 'Pretendard, sans-serif' }}>항공·비자·숙박까지 협조가 필요한 경우 별도 안내 요청</p>
                    </div>
                  </div>
                  <div className="flex flex-col sm:flex-row gap-3 md:gap-4 mt-6">
                    <Link
                      to="/apply"
                      className="inline-flex items-center justify-center gap-3 bg-[#8B7355] hover:bg-[#6d5a42] text-white px-6 md:px-8 py-3 md:py-3.5 rounded-full transition-all whitespace-nowrap cursor-pointer shadow-md hover:shadow-lg"
                    >
                      <span className="text-sm md:text-base font-semibold" style={{ fontFamily: 'Pretendard, sans-serif' }}>프로그램 신청하기</span>
                      <i className="ri-arrow-right-line text-base md:text-lg"></i>
                    </Link>
                    <Link
                      to="/experience#korea-experience"
                      className="inline-flex items-center justify-center gap-3 bg-white hover:bg-gray-50 text-[#2C2416] border-2 border-[#2C2416] px-6 md:px-8 py-3 md:py-3.5 rounded-full transition-all whitespace-nowrap cursor-pointer shadow-md hover:shadow-lg"
                    >
                      <span className="text-sm md:text-base font-semibold" style={{ fontFamily: 'Pretendard, sans-serif' }}>체험 정보보기</span>
                      <i className="ri-map-pin-line text-base md:text-lg"></i>
                    </Link>
                  </div>
                </div>
                <div className="relative h-[400px] md:h-[550px] rounded-lg overflow-hidden order-1 lg:order-2">
                  <img
                    src="https://readdy.ai/api/search-image?query=japanese%20high%20school%20students%20exploring%20vibrant%20seoul%20city%20experiencing%20korean%20pop%20culture%20and%20beauty%20industry%2C%20students%20visiting%20modern%20k-beauty%20store%20and%20trying%20makeup%20products%20with%20excitement%2C%20bright%20contemporary%20seoul%20shopping%20district%20with%20colorful%20displays%2C%20professional%20educational%20photography%20style%2C%20cultural%20exchange%20and%20k-culture%20immersion%20moment%2C%20warm%20natural%20lighting&width=800&height=1000&seq=korea-experience-main-001&orientation=portrait"
                    alt="한국 유학 체험"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>

              {/* Partner Logos */}
              <div className="mb-12 md:mb-16">
                <h4 className="text-xl md:text-2xl font-bold text-[#2C2416] mb-6 md:mb-8 text-center" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                  연계 기관
                </h4>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8 items-center">
                  <div className="bg-white p-4 md:p-6 rounded-lg border border-[#E8DFD0] flex items-center justify-center h-20 md:h-24">
                    <span className="text-base md:text-lg font-bold text-[#2C2416]" style={{ fontFamily: 'Pretendard, sans-serif' }}>아모레퍼시픽</span>
                  </div>
                  <div className="bg-white p-4 md:p-6 rounded-lg border border-[#E8DFD0] flex items-center justify-center h-20 md:h-24">
                    <span className="text-base md:text-lg font-bold text-[#2C2416]" style={{ fontFamily: 'Pretendard, sans-serif' }}>시사쿡요리학원</span>
                  </div>
                  <div className="bg-white p-4 md:p-6 rounded-lg border border-[#E8DFD0] flex items-center justify-center h-20 md:h-24">
                    <span className="text-base md:text-lg font-bold text-[#2C2416]" style={{ fontFamily: 'Pretendard, sans-serif' }}>Gen.G</span>
                  </div>
                  <div className="bg-white p-4 md:p-6 rounded-lg border border-[#E8DFD0] flex items-center justify-center h-20 md:h-24">
                    <span className="text-sm md:text-base font-bold text-[#2C2416] text-center" style={{ fontFamily: 'Pretendard, sans-serif' }}>모어댄스뮤직아카데미</span>
                  </div>
                </div>
                <p className="text-center text-base md:text-lg text-[#6B5D4F] mt-4 md:mt-6 font-medium" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                  외 50여 개 체험처 연계 가능
                </p>
              </div>

              {/* Gallery */}
              <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
                <div className="aspect-[3/4] rounded-lg overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=japanese%20students%20visiting%20iconic%20seoul%20landmark%20gyeongbokgung%20palace%20and%20traditional%20hanok%20village%2C%20students%20wearing%20casual%20modern%20clothes%20taking%20photos%20and%20exploring%20korean%20traditional%20architecture%20with%20genuine%20interest%2C%20bright%20sunny%20day%20with%20beautiful%20traditional%20buildings%2C%20professional%20documentary%20photography%20style%2C%20authentic%20cultural%20tourism%20and%20heritage%20exploration%20moment%2C%20warm%20natural%20lighting&width=600&height=800&seq=korea-gallery-tour-01&orientation=portrait"
                    alt="서울 명소 탐방"
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-500 cursor-pointer"
                  />
                </div>
                <div className="aspect-[3/4] rounded-lg overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=japanese%20students%20experiencing%20korean%20beauty%20and%20cosmetics%20workshop%20in%20modern%20bright%20studio%2C%20students%20trying%20k-beauty%20makeup%20products%20and%20learning%20about%20korean%20beauty%20trends%20with%20excitement%2C%20professional%20educational%20photography%2C%20engaging%20hands-on%20cultural%20experience%20with%20beauty%20experts%2C%20clean%20and%20contemporary%20setting%20with%20natural%20lighting%20and%20colorful%20product%20displays&width=600&height=800&seq=korea-gallery-beauty-02&orientation=portrait"
                    alt="K-뷰티 체험"
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-500 cursor-pointer"
                  />
                </div>
                <div className="aspect-[3/4] rounded-lg overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=japanese%20students%20touring%20modern%20korean%20technology%20company%20office%20in%20gangnam%20seoul%2C%20students%20wearing%20visitor%20badges%20looking%20at%20innovative%20tech%20displays%20and%20startup%20workspace%20with%20interest%2C%20bright%20modern%20interior%20with%20glass%20walls%20and%20contemporary%20design%2C%20professional%20educational%20documentary%20photography%2C%20career%20exploration%20and%20industry%20visit%20atmosphere%2C%20natural%20indoor%20lighting&width=600&height=800&seq=korea-gallery-company-03&orientation=portrait"
                    alt="한국 기업 탐방"
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-500 cursor-pointer"
                  />
                </div>
                <div className="aspect-[3/4] rounded-lg overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=japanese%20students%20learning%20korean%20cooking%20and%20culinary%20skills%20in%20professional%20cooking%20studio%2C%20students%20wearing%20aprons%20and%20chef%20hats%20preparing%20traditional%20korean%20food%20with%20instructor%20guidance%2C%20bright%20modern%20kitchen%20classroom%20with%20stainless%20steel%20equipment%2C%20professional%20educational%20photography%2C%20hands-on%20cultural%20learning%20through%20food%20experience%2C%20warm%20natural%20lighting&width=600&height=800&seq=korea-gallery-cooking-04&orientation=portrait"
                    alt="전문 자격증 취득"
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-500 cursor-pointer"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* University Tour Program */}
      {activeTab === 'university' && (
        <section id="university" className="py-16 md:py-24 px-6">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-16 md:mb-20">
              <span className="text-sm md:text-base tracking-[0.3em] text-[#8B7355] font-medium uppercase mb-4 md:mb-5 block" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                University Tour
              </span>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#2C2416] mb-3 md:mb-4 tracking-tight" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                대학 탐방 프로그램
              </h2>
              <div className="w-full max-w-[300px] h-0.5 bg-[#8B7355] mx-auto mt-4 md:mt-6 mb-6 md:mb-8"></div>
              <p className="text-base md:text-lg text-[#6B5D4F] max-w-3xl mx-auto leading-relaxed font-medium" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                서울 소재 대학교 방문을 통해<br />
                학과 정보 및 대학 환경을 이해하는 진로 연계형 탐방 프로그램입니다.
              </p>
            </div>

            {/* Main Image */}
            <div className="relative h-[300px] md:h-[500px] rounded-lg overflow-hidden mb-16 md:mb-24">
              <img
                src="https://readdy.ai/api/search-image?query=korean%20high%20school%20students%20touring%20beautiful%20modern%20university%20campus%20in%20seoul%20with%20contemporary%20architecture%2C%20students%20walking%20through%20campus%20grounds%20with%20senior%20student%20guide%20showing%20facilities%20and%20buildings%2C%20bright%20sunny%20day%20with%20green%20trees%20and%20open%20spaces%2C%20professional%20educational%20documentary%20photography%2C%20inspiring%20academic%20atmosphere%20and%20future%20planning%20moment%2C%20natural%20daylight&width=1200&height=800&seq=university-tour-main-002&orientation=landscape"
                alt="대학 탐방"
                className="w-full h-full object-cover"
              />
            </div>

            {/* Overview with Icons */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-16 mb-24 md:mb-32">
              <div className="bg-[#F5EFE7] p-8 md:p-10 rounded-lg text-center">
                <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 md:mb-6 bg-[#8B7355] rounded-full">
                  <i className="ri-time-line text-xl md:text-2xl text-white"></i>
                </div>
                <h3 className="text-lg md:text-xl font-bold text-[#2C2416] mb-4 md:mb-6" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                  운영 시간
                </h3>
                <p className="text-base md:text-lg text-[#6B5D4F] font-medium leading-relaxed" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                  2시간
                </p>
              </div>

              <div className="bg-[#F5EFE7] p-8 md:p-10 rounded-lg text-center">
                <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 md:mb-6 bg-[#8B7355] rounded-full">
                  <i className="ri-user-line text-xl md:text-2xl text-white"></i>
                </div>
                <h3 className="text-lg md:text-xl font-bold text-[#2C2416] mb-4 md:mb-6" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                  운영 대상
                </h3>
                <p className="text-base md:text-lg text-[#6B5D4F] font-medium leading-relaxed" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                  한국 중·고등학생
                </p>
              </div>

              <div className="bg-[#F5EFE7] p-8 md:p-10 rounded-lg text-center">
                <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 md:mb-6 bg-[#8B7355] rounded-full">
                  <i className="ri-group-line text-xl md:text-2xl text-white"></i>
                </div>
                <h3 className="text-lg md:text-xl font-bold text-[#2C2416] mb-4 md:mb-6" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                  운영 방식
                </h3>
                <p className="text-base md:text-lg text-[#6B5D4F] font-medium leading-relaxed" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                  재학생 인솔을 통한<br />
                  학과 중심 탐방
                </p>
              </div>
            </div>

            {/* Main Content */}
            <div className="mb-24 md:mb-32">
              <h3 className="text-2xl md:text-3xl font-bold text-[#2C2416] mb-10 md:mb-12 text-center" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                주요 활동
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12">
                <div className="text-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 md:mb-6 bg-[#F5EFE7] rounded-full">
                    <i className="ri-building-line text-xl md:text-2xl text-[#8B7355]"></i>
                  </div>
                  <h4 className="text-base md:text-lg font-bold text-[#2C2416] mb-3 md:mb-4" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    대학교 방문
                  </h4>
                  <p className="text-sm md:text-base text-[#6B5D4F] font-medium leading-relaxed" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    실제 대학 캠퍼스를 방문하여 학교 분위기를 직접 체험합니다
                  </p>
                </div>

                <div className="text-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 md:mb-6 bg-[#F5EFE7] rounded-full">
                    <i className="ri-map-pin-line text-xl md:text-2xl text-[#8B7355]"></i>
                  </div>
                  <h4 className="text-base md:text-lg font-bold text-[#2C2416] mb-3 md:mb-4" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    학과 및 시설 라운딩
                  </h4>
                  <p className="text-sm md:text-base text-[#6B5D4F] font-medium leading-relaxed" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    학과 건물과 커뮤니티 시설을 둘러보며 대학 환경을 이해합니다
                  </p>
                </div>

                <div className="text-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 md:mb-6 bg-[#F5EFE7] rounded-full">
                    <i className="ri-user-voice-line text-xl md:text-2xl text-[#8B7355]"></i>
                  </div>
                  <h4 className="text-base md:text-lg font-bold text-[#2C2416] mb-3 md:mb-4" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    대학 생활 소개
                  </h4>
                  <p className="text-sm md:text-base text-[#6B5D4F] font-medium leading-relaxed" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    재학생의 생생한 경험담을 듣고 궁금한 점을 질문합니다
                  </p>
                </div>
              </div>
            </div>

            {/* Features */}
            <div className="bg-[#F5EFE7] py-12 md:py-20 px-8 md:px-12 rounded-lg mb-12 md:mb-16">
              <h3 className="text-2xl md:text-3xl font-bold text-[#2C2416] mb-10 md:mb-12 text-center" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                프로그램 특징
              </h3>
              <div className="max-w-3xl mx-auto space-y-5 md:space-y-6">
                <div className="flex items-start gap-3 md:gap-4">
                  <div className="w-2 h-2 bg-[#8B7355] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-base md:text-lg text-[#5A4A3A] font-medium leading-relaxed" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    사전 정보 습득을 바탕으로 자신의 적성과 흥미를 고려한 진학 학과 탐색
                  </p>
                </div>
                <div className="flex items-start gap-3 md:gap-4">
                  <div className="w-2 h-2 bg-[#8B7355] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-base md:text-lg text-[#5A4A3A] font-medium leading-relaxed" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    방문 가능한 대학교 리스트 제공 후 선택 필요
                  </p>
                </div>
                <div className="flex items-start gap-3 md:gap-4">
                  <div className="w-2 h-2 bg-[#8B7355] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-base md:text-lg text-[#5A4A3A] font-medium leading-relaxed" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    탐방 당일 학생 개별 이동 (사전 집합 장소 별도 안내 예정)
                  </p>
                </div>
              </div>
            </div>

            {/* CTA */}
            <div className="text-center">
              <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center">
                <Link
                  to="/apply"
                  className="inline-flex items-center justify-center gap-3 bg-[#8B7355] hover:bg-[#6d5a42] text-white px-6 md:px-8 py-3 md:py-3.5 rounded-full transition-all whitespace-nowrap cursor-pointer shadow-md hover:shadow-lg"
                >
                  <span className="text-sm md:text-base font-semibold" style={{ fontFamily: 'Pretendard, sans-serif' }}>프로그램 신청하기</span>
                  <i className="ri-arrow-right-line text-base md:text-lg"></i>
                </Link>
                <a
                  href="https://brancheduinfo.readdy.co"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-3 bg-white hover:bg-gray-50 text-[#2C2416] border-2 border-[#2C2416] px-6 md:px-8 py-3 md:py-3.5 rounded-full transition-all whitespace-nowrap cursor-pointer shadow-md hover:shadow-lg"
                >
                  <span className="text-sm md:text-base font-semibold" style={{ fontFamily: 'Pretendard, sans-serif' }}>대학 정보보기</span>
                  <i className="ri-building-line text-base md:text-lg"></i>
                </a>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Career Lecture Program */}
      {activeTab === 'career' && (
        <section id="career" className="py-16 md:py-24 px-6">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-16 md:mb-20">
              <span className="text-sm md:text-base tracking-[0.3em] text-[#8B7355] font-medium uppercase mb-4 md:mb-5 block" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                Career Seminar
              </span>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#2C2416] mb-3 md:mb-4 tracking-tight" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                진로 특강 프로그램
              </h2>
              <div className="w-full max-w-[280px] h-0.5 bg-[#8B7355] mx-auto mt-4 md:mt-6 mb-6 md:mb-8"></div>
              <p className="text-base md:text-lg text-[#6B5D4F] max-w-3xl mx-auto leading-relaxed font-medium" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                미래사회의 변화, 자기인식, 실행의 세 가지 주제를 통해<br />
                진로 방향을 설정하는 참여형 특강 프로그램입니다.
              </p>
            </div>

            {/* Main Image */}
            <div className="relative h-[300px] md:h-[500px] rounded-lg overflow-hidden mb-16 md:mb-24">
              <img
                src="https://readdy.ai/api/search-image?query=professional%20career%20counselor%20giving%20inspiring%20motivational%20presentation%20to%20engaged%20korean%20high%20school%20students%20in%20modern%20bright%20auditorium%2C%20large%20screen%20displaying%20future%20career%20paths%20and%20industry%20trends%20graphs%2C%20students%20sitting%20attentively%20taking%20notes%20and%20raising%20hands%20with%20enthusiasm%2C%20warm%20stage%20lighting%2C%20educational%20empowerment%20and%20personal%20growth%20atmosphere%2C%20natural%20indoor%20lighting&width=1200&height=800&seq=career-lecture-main-002&orientation=landscape"
                alt="진로 특강"
                className="w-full h-full object-cover"
              />
            </div>

            {/* Overview with Icons */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-16 mb-24 md:mb-32">
              <div className="bg-[#F5EFE7] p-8 md:p-10 rounded-lg text-center">
                <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 md:mb-6 bg-[#8B7355] rounded-full">
                  <i className="ri-time-line text-xl md:text-2xl text-white"></i>
                </div>
                <h3 className="text-lg md:text-xl font-bold text-[#2C2416] mb-4 md:mb-6" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                  운영 시간
                </h3>
                <p className="text-base md:text-lg text-[#6B5D4F] font-medium leading-relaxed" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                  1~2시간<br />
                  (협의 가능)
                </p>
              </div>

              <div className="bg-[#F5EFE7] p-8 md:p-10 rounded-lg text-center">
                <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 md:mb-6 bg-[#8B7355] rounded-full">
                  <i className="ri-user-line text-xl md:text-2xl text-white"></i>
                </div>
                <h3 className="text-lg md:text-xl font-bold text-[#2C2416] mb-4 md:mb-6" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                  운영 대상
                </h3>
                <p className="text-base md:text-lg text-[#6B5D4F] font-medium leading-relaxed" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                  한국 초·중·고등학생
                </p>
              </div>

              <div className="bg-[#F5EFE7] p-8 md:p-10 rounded-lg text-center">
                <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 md:mb-6 bg-[#8B7355] rounded-full">
                  <i className="ri-school-line text-xl md:text-2xl text-white"></i>
                </div>
                <h3 className="text-lg md:text-xl font-bold text-[#2C2416] mb-4 md:mb-6" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                  운영 방식
                </h3>
                <p className="text-base md:text-lg text-[#6B5D4F] font-medium leading-relaxed" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                  신청 학교 강당 또는<br />
                  특별실에서 진행
                </p>
              </div>
            </div>

            {/* Main Content */}
            <div className="mb-24 md:mb-32">
              <h3 className="text-2xl md:text-3xl font-bold text-[#2C2416] mb-12 md:mb-16 text-center" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                주요 내용
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12">
                <div className="text-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 md:mb-6 bg-[#F5EFE7] rounded-full">
                    <i className="ri-robot-line text-xl md:text-2xl text-[#8B7355]"></i>
                  </div>
                  <h4 className="text-base md:text-lg font-bold text-[#2C2416] mb-3 md:mb-4" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    AI 시대의 진로
                  </h4>
                  <p className="text-sm md:text-base text-[#6B5D4F] font-medium leading-relaxed" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    인공지능 시대의 기술 변화가 진로에 미치는 영향을 이해합니다
                  </p>
                </div>

                <div className="text-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 md:mb-6 bg-[#F5EFE7] rounded-full">
                    <i className="ri-lightbulb-line text-xl md:text-2xl text-[#8B7355]"></i>
                  </div>
                  <h4 className="text-base md:text-lg font-bold text-[#2C2416] mb-3 md:mb-4" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    미래 사회 이해
                  </h4>
                  <p className="text-sm md:text-base text-[#6B5D4F] font-medium leading-relaxed" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    생성형 AI가 만들어갈 미래 사회에 대해 안내합니다
                  </p>
                </div>

                <div className="text-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 md:mb-6 bg-[#F5EFE7] rounded-full">
                    <i className="ri-compass-line text-xl md:text-2xl text-[#8B7355]"></i>
                  </div>
                  <h4 className="text-base md:text-lg font-bold text-[#2C2416] mb-3 md:mb-4" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    진로 방향 설정
                  </h4>
                  <p className="text-sm md:text-base text-[#6B5D4F] font-medium leading-relaxed" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    학생 스스로 진로 방향을 설정하도록 돕는 강의를 구성합니다
                  </p>
                </div>
              </div>
            </div>

            {/* Important Notes */}
            <div className="bg-[#F5EFE7] py-12 md:py-16 px-8 md:px-12 rounded-lg">
              <h3 className="text-xl md:text-2xl font-bold text-[#2C2416] mb-8 md:mb-10 text-center" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                참고 사항
              </h3>
              <div className="space-y-5 md:space-y-6 max-w-3xl mx-auto">
                <div className="flex items-start gap-3 md:gap-4">
                  <div className="w-2 h-2 bg-[#8B7355] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-base md:text-lg text-[#5A4A3A] font-medium leading-relaxed" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    강사비는 차시별 상이 (신청 후 별도 안내)
                  </p>
                </div>
                <div className="flex items-start gap-3 md:gap-4">
                  <div className="w-2 h-2 bg-[#8B7355] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-base md:text-lg text-[#5A4A3A] font-medium leading-relaxed" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    사전 강의 기자재 체크 요청
                  </p>
                </div>
                <div className="flex items-start gap-3 md:gap-4">
                  <div className="w-2 h-2 bg-[#8B7355] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-base md:text-lg text-[#5A4A3A] font-medium leading-relaxed" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    강사 생수 준비 요청
                  </p>
                </div>
              </div>
            </div>

            {/* CTA */}
            <div className="text-center mt-12 md:mt-16">
              <Link
                to="/apply"
                className="inline-flex items-center justify-center gap-3 bg-[#8B7355] hover:bg-[#6d5a42] text-white px-6 md:px-8 py-3 md:py-3.5 rounded-full transition-all whitespace-nowrap cursor-pointer shadow-md hover:shadow-lg"
              >
                <span className="text-sm md:text-base font-semibold" style={{ fontFamily: 'Pretendard, sans-serif' }}>프로그램 신청하기</span>
                <i className="ri-arrow-right-line text-base md:text-lg"></i>
              </Link>
            </div>
          </div>
        </section>
      )}

      {/* Startup & Certification Program */}
      {activeTab === 'startup' && (
        <section id="startup" className="py-16 md:py-24 px-6">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-16 md:mb-20">
              <span className="text-sm md:text-base tracking-[0.3em] text-[#8B7355] font-medium uppercase mb-4 md:mb-5 block" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                Startup & Certification
              </span>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#2C2416] mb-3 md:mb-4 tracking-tight" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                창업 & 자격증 취득과정
              </h2>
              <div className="w-full max-w-[340px] h-0.5 bg-[#8B7355] mx-auto mt-4 md:mt-6 mb-6 md:mb-8"></div>
              <p className="text-base md:text-lg text-[#6B5D4F] max-w-3xl mx-auto leading-relaxed font-medium" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                창업과 실무 역량을 동시에 키울 수 있도록 구성된 프로그램으로,<br />
                다양한 분야의 전문가와 함께 창업 아이디어 기획부터 실전 프로젝트까지 경험할 수 있습니다.<br />
                또한 분야별 자격증 취득 과정과 연계하여 학생들이 미래 사회에 필요한<br />
                실질적인 역량을 갖추고 자신의 진로와 직업 가능성을 확장할 수 있도록 지원합니다.
              </p>
            </div>

            {/* Main Image */}
            <div className="relative h-[300px] md:h-[500px] rounded-lg overflow-hidden mb-16 md:mb-24">
              <img
                src="https://readdy.ai/api/search-image?query=young%20korean%20entrepreneurs%20and%20students%20collaborating%20on%20startup%20business%20project%20in%20modern%20bright%20coworking%20space%2C%20brainstorming%20with%20laptops%20tablets%20and%20whiteboards%20showing%20business%20plans%2C%20professional%20mentors%20guiding%20team%20discussions%2C%20innovative%20creative%20atmosphere%20with%20natural%20lighting%20and%20plants%2C%20professional%20documentary%20photography%20style%2C%20entrepreneurship%20education%20and%20skill%20development%20theme&width=1200&height=800&seq=startup-main-001&orientation=landscape"
                alt="창업 & 자격증 취득과정"
                className="w-full h-full object-cover"
              />
            </div>

            {/* Main Content */}
            <div className="mb-24 md:mb-32">
              <h3 className="text-2xl md:text-3xl font-bold text-[#2C2416] mb-12 md:mb-16 text-center" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                프로그램 특징
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12">
                <div className="text-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 md:mb-6 bg-[#F5EFE7] rounded-full">
                    <i className="ri-lightbulb-flash-line text-xl md:text-2xl text-[#8B7355]"></i>
                  </div>
                  <h4 className="text-base md:text-lg font-bold text-[#2C2416] mb-3 md:mb-4" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    창업 아이디어 기획
                  </h4>
                  <p className="text-sm md:text-base text-[#6B5D4F] font-medium leading-relaxed" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    전문가와 함께 창의적인 비즈니스 아이디어를 발굴하고 구체화합니다
                  </p>
                </div>

                <div className="text-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 md:mb-6 bg-[#F5EFE7] rounded-full">
                    <i className="ri-team-line text-xl md:text-2xl text-[#8B7355]"></i>
                  </div>
                  <h4 className="text-base md:text-lg font-bold text-[#2C2416] mb-3 md:mb-4" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    실전 프로젝트 경험
                  </h4>
                  <p className="text-sm md:text-base text-[#6B5D4F] font-medium leading-relaxed" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    실제 창업 과정을 체험하며 실무 역량을 키웁니다
                  </p>
                </div>

                <div className="text-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 md:mb-6 bg-[#F5EFE7] rounded-full">
                    <i className="ri-award-line text-xl md:text-2xl text-[#8B7355]"></i>
                  </div>
                  <h4 className="text-base md:text-lg font-bold text-[#2C2416] mb-3 md:mb-4" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    자격증 취득 지원
                  </h4>
                  <p className="text-sm md:text-base text-[#6B5D4F] font-medium leading-relaxed" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    분야별 전문 자격증 취득을 통해 실질적인 역량을 인증받습니다
                  </p>
                </div>
              </div>
            </div>

            {/* Program Areas */}
            <div className="mb-24 md:mb-32">
              <h3 className="text-2xl md:text-3xl font-bold text-[#2C2416] mb-12 md:mb-16 text-center" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                주요 분야
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10">
                <div className="bg-[#F5EFE7] p-8 md:p-10 rounded-lg">
                  <div className="flex items-start gap-4 mb-4">
                    <div className="w-10 h-10 flex items-center justify-center bg-[#8B7355] rounded-full flex-shrink-0">
                      <i className="ri-store-line text-lg text-white"></i>
                    </div>
                    <div>
                      <h4 className="text-lg md:text-xl font-bold text-[#2C2416] mb-3" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                        창업 과정
                      </h4>
                      <ul className="space-y-2 text-sm md:text-base text-[#6B5D4F] font-medium" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                        <li className="flex items-start gap-2">
                          <span className="w-1.5 h-1.5 bg-[#8B7355] rounded-full mt-2 flex-shrink-0"></span>
                          <span>비즈니스 모델 개발</span>
                        </li>
                        <li className="flex items-start gap-2">
                          <span className="w-1.5 h-1.5 bg-[#8B7355] rounded-full mt-2 flex-shrink-0"></span>
                          <span>마케팅 전략 수립</span>
                        </li>
                        <li className="flex items-start gap-2">
                          <span className="w-1.5 h-1.5 bg-[#8B7355] rounded-full mt-2 flex-shrink-0"></span>
                          <span>재무 관리 기초</span>
                        </li>
                        <li className="flex items-start gap-2">
                          <span className="w-1.5 h-1.5 bg-[#8B7355] rounded-full mt-2 flex-shrink-0"></span>
                          <span>피칭 및 프레젠테이션</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="bg-[#F5EFE7] p-8 md:p-10 rounded-lg">
                  <div className="flex items-start gap-4 mb-4">
                    <div className="w-10 h-10 flex items-center justify-center bg-[#8B7355] rounded-full flex-shrink-0">
                      <i className="ri-file-text-line text-lg text-white"></i>
                    </div>
                    <div>
                      <h4 className="text-lg md:text-xl font-bold text-[#2C2416] mb-3" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                        자격증 취득 과정
                      </h4>
                      <ul className="space-y-2 text-sm md:text-base text-[#6B5D4F] font-medium" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                        <li className="flex items-start gap-2">
                          <span className="w-1.5 h-1.5 bg-[#8B7355] rounded-full mt-2 flex-shrink-0"></span>
                          <span>IT 관련 자격증</span>
                        </li>
                        <li className="flex items-start gap-2">
                          <span className="w-1.5 h-1.5 bg-[#8B7355] rounded-full mt-2 flex-shrink-0"></span>
                          <span>디자인 전문 자격증</span>
                        </li>
                        <li className="flex items-start gap-2">
                          <span className="w-1.5 h-1.5 bg-[#8B7355] rounded-full mt-2 flex-shrink-0"></span>
                          <span>마케팅 자격증</span>
                        </li>
                        <li className="flex items-start gap-2">
                          <span className="w-1.5 h-1.5 bg-[#8B7355] rounded-full mt-2 flex-shrink-0"></span>
                          <span>기타 분야별 전문 자격증</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Important Notes */}
            <div className="bg-[#F5EFE7] py-12 md:py-16 px-8 md:px-12 rounded-lg">
              <h3 className="text-xl md:text-2xl font-bold text-[#2C2416] mb-8 md:mb-10 text-center" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                참고 사항
              </h3>
              <div className="space-y-5 md:space-y-6 max-w-3xl mx-auto">
                <div className="flex items-start gap-3 md:gap-4">
                  <div className="w-2 h-2 bg-[#8B7355] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-base md:text-lg text-[#5A4A3A] font-medium leading-relaxed" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    프로그램 기간 및 내용은 참가자의 수준과 목표에 따라 맞춤 구성 가능
                  </p>
                </div>
                <div className="flex items-start gap-3 md:gap-4">
                  <div className="w-2 h-2 bg-[#8B7355] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-base md:text-lg text-[#5A4A3A] font-medium leading-relaxed" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    자격증 취득 과정은 선택형으로 운영되며, 별도 비용 발생 가능
                  </p>
                </div>
                <div className="flex items-start gap-3 md:gap-4">
                  <div className="w-2 h-2 bg-[#8B7355] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-base md:text-lg text-[#5A4A3A] font-medium leading-relaxed" style={{ fontFamily: 'Pretendard, sans-serif' }}>
                    전문가 멘토링 및 실습 재료비는 프로그램 내용에 따라 별도 안내
                  </p>
                </div>
              </div>
            </div>

            {/* CTA */}
            <div className="text-center mt-12 md:mt-16">
              <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center">
                <Link
                  to="/apply"
                  className="inline-flex items-center justify-center gap-3 bg-[#8B7355] hover:bg-[#6d5a42] text-white px-6 md:px-8 py-3 md:py-3.5 rounded-full transition-all whitespace-nowrap cursor-pointer shadow-md hover:shadow-lg"
                >
                  <span className="text-sm md:text-base font-semibold" style={{ fontFamily: 'Pretendard, sans-serif' }}>프로그램 신청하기</span>
                  <i className="ri-arrow-right-line text-base md:text-lg"></i>
                </Link>
                <a
                  href="https://brancheduinfo.readdy.co"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-3 bg-white hover:bg-gray-50 text-[#2C2416] border-2 border-[#2C2416] px-6 md:px-8 py-3 md:py-3.5 rounded-full transition-all whitespace-nowrap cursor-pointer shadow-md hover:shadow-lg"
                >
                  <span className="text-sm md:text-base font-semibold" style={{ fontFamily: 'Pretendard, sans-serif' }}>세부정보 보기</span>
                  <i className="ri-file-list-line text-base md:text-lg"></i>
                </a>
              </div>
            </div>
          </div>
        </section>
      )}

      <Footer />
    </div>
  );
};

export default ProgramsPage;